module.exports = __webpack_public_path__ + "static/media/gw.1ea24463.svg";